import React from "react";
import { Heading, Subheading } from "../design/heading";
import { Text } from "../design/text";
import { Button } from "../design/button";
import { XMarkIcon } from "@heroicons/react/20/solid";

interface ProgressBarProps {
  progress: number;
  message?: string;
  subtitle?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  message,
  subtitle,
}) => {
  return (
    <div className="flex flex-col justify-center w-full p-4 mb-4 bg-white border border-gray-300 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
      {message && <Heading>{message}</Heading>}
      {subtitle && <Subheading>{subtitle}</Subheading>}
      <div className="w-full h-4 mt-2 bg-gray-200 rounded-full">
        <div
          className="h-4 transition-all bg-blue-500 rounded-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <Text className="text-right">{progress}%</Text>
    </div>
  );
};

export default ProgressBar;
